import { render } from "./404.vue?vue&type=template&id=59980ee4"
const script = {}
script.render = render

export default script